export default __webpack_public_path__ + "static/media/Harness of the Deathstalker.1651ba9e.jpg";